import { render } from "./Step0.vue?vue&type=template&id=05b39a42&ts=true"
import script from "./Step0.vue?vue&type=script&lang=ts"
export * from "./Step0.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/custom-client/enablewa-token-refresher/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__